import React from 'react'

export const withCustomOpener =
  (DropdownInputSuggestionsComponent) =>
  ({ children, ...props }) => {
    return <DropdownInputSuggestionsComponent {...props}>{children}</DropdownInputSuggestionsComponent>
  }
